import axios from "axios";
import { setCookie, getCookie, removeCookie } from "./cookies";
import { datadogRum } from "@datadog/browser-rum";
import { resolvePhotoUrl } from "utils/photo";
export const BASE_URL = process.env.REACT_APP_API_URL_SERVER;

export default {
	actions: {
		doSignIn(values) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/user/login`, {
						email: values.email,
						password: values.password,
					})
					.then((response) => {
						datadogRum.setUser({
							name: response.data.data.profile.name,
              email:values.email
						});
						removeCookie("auth_token");
						removeCookie("profile");
						removeCookie("publisher");
						removeCookie("photo_profile");
						setCookie("auth_token", response.data.data.token);
						setCookie("profile", response.data.data.profile.name);
						setCookie("publisher", response.data.data.profile.role_code);
						setCookie(
							"photo_profile",
							resolvePhotoUrl(
								response.data.data.profile.profile_photo ||
									response.data.data.profile.photo_profile,
							),
						);
						setCookie(
							"ip_base_number",
							response.data.data.profile.ip_base_number,
						);
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		doSignOut() {
			// Sesi lokal dibersihkan baik logout di server berhasil maupun gagal,
			// supaya user tidak tertinggal dalam keadaan seolah masih login.
			const clearLocalSession = () => {
				removeCookie("auth_token");
				removeCookie("profile");
				removeCookie("publisher");
				removeCookie("photo_profile");
				removeCookie("ip_base_number");
			};

			return new Promise((resolve, reject) => {
				axios
					.post(
						`${BASE_URL}/api/user/logout`,
						{},
						{
							headers: {
								Authorization: `Bearer ${getCookie("auth_token")}`,
							},
						},
					)
					.then((response) => {
						clearLocalSession();
						resolve(response.data.data);
					})
					.catch((err) => {
						clearLocalSession();
						reject(err);
					});
			});
		},
		refreshToken() {
			return new Promise((resolve, reject) => {
				axios
					.post(
						`${BASE_URL}/api/user/refreshToken`,
						{},
						{
							headers: {
								Authorization: `Bearer ${getCookie("auth_token")}`,
							},
						},
					)
					.then((response) => {
						// console.log('lala', response)
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		doSignUp(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/user/register`, data, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		saveLagu(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/song/song-register`, data, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		saveHargaLagu(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/song/song-price`, data, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		savePenciptaLagu(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/user/creator-register`, data, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
							"Content-Type": "multipart/form-data",
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		saveAhliWaris(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/user/heir-register`, data, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
							"Content-Type": "multipart/form-data",
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		saveAdmin(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/user/admin-register`, data, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
							"Content-Type": "application/x-www-form-urlencoded",
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		saveRoleAdmin(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/ref/create-role`, data, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		saveTransaksi(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/transaction/create-transaction`, data, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		kirimEmail(id, type) {
			return new Promise((resolve, reject) => {
				axios
					.post(
						`${BASE_URL}/api/transaction/send-email/${id}/${type}`,
						{},
						{
							headers: {
								Authorization: `Bearer ${getCookie("auth_token")}`,
							},
						},
					)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		postBulkPenciptaExcel(file) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/user/bulk-excel`, file, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		postBulkSong(file) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/song/bulk-excel`, file, {
						headers: {
							Authorization: `Bearer ${getCookie("auth_token")}`,
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		joinInterest() {
			return new Promise((resolve, reject) => {
				axios
					.post(
						`${BASE_URL}/api/user/join-interest`,
						{},
						{
							headers: {
								Authorization: `Bearer ${getCookie("auth_token")}`,
							},
						},
					)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		forgotPassword(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${BASE_URL}/api/user/forgotPassword`, data, {
						headers: {
							"Content-Type": "application/x-www-form-urlencoded",
						},
					})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
	},
};
